export default "__VITE_ASSET__BXd3qyi___"